import { useFeatureFlag } from '@moda/portal-stanchions';

export const useUsDomesticShippingFeeOptimization = () =>
  useFeatureFlag('us-domestic-shipping-fee-optimization', [
    { default: 'controller' },
    { getFromTreatment: treatment => String(treatment) }
  ]);
